import cn from 'clsx'
import Link from 'next/link';
import { CareerListing } from '../../../../apps/benmax/src/types/sanity.types';

import BlockArrow from 'shared-components/images/blockArrow'

import s from './SingleCareerListing.module.sass'
import Copy from '../Copy/Copy';
import HowToApply from './HowToApply';

function SingleCareerListing({ listing }: { listing: CareerListing }) {
    const { title, copy } = listing

    return (
        <div className={s.SingleCareerListing}>
            <div className={cn(s.Cont, 'container')}>
                <Link href="/careers" className={cn(s.Back, 'smallCaps')}>
                    {BlockArrow}
                    Back to all
                </Link>

                <div className={s.Main}>
                    <div className={s.Content}>
                        <h1 className={s.Title}>{title}</h1>
                        <Copy copy={copy} />
                    </div>

                    <HowToApply listing={listing} />
                </div>
            </div>
        </div>
    )
}

export default SingleCareerListing
